module.exports = __webpack_public_path__ + "img/stakeTokens.41585aef.svg";